import { useLocation } from 'react-router-dom';
import { WIKI_DOCS } from './wikiSections';

export const useIsLegacyWikiDocs = (): boolean => {
  const { pathname } = useLocation();
  return pathname === WIKI_DOCS || pathname.startsWith(`${WIKI_DOCS}/`);
};
